'use client';

import React from 'react';
import { Flex, Grid, GridItem, Skeleton } from '@skin-seoul/design-system';
const TrendingProductsListSkeleton = () => {
  const skeletonItems = Array.from({
    length: 4
  }, (_, index) => index);
  return <Grid alignItems="center" gridGap={{
    base: 3,
    tablet: 6,
    desktop: 6
  }} gridTemplateColumns="repeat(2, minmax(0, 1fr))" height="100%" width="100%" display={{
    tablet: 'none',
    base: 'grid'
  }} data-sentry-element="Grid" data-sentry-component="TrendingProductsListSkeleton" data-sentry-source-file="TrendingProductsListSkeleton.tsx">
      {skeletonItems.map(index => <GridItem key={`skeleton-list-${index}`} width="100%" minWidth={0}>
          <Flex>
            <Skeleton height="350px" width="100%" borderRadius="8px" />
          </Flex>
        </GridItem>)}
    </Grid>;
};
export default TrendingProductsListSkeleton;